import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface PlanAnualTrabajoPayload {
  plan: string;
  objetivo: number;
  fecha_inicio: string;
  fecha_fin: string;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface PlanAnualTrabajo {
  id?: number;
  objetivo: number;
  fecha_inicio: string;
  fecha_fin: string;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface PlanAnualTrabajoResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class PlanAnualTrabajoService {
  private readonly apiUrl = `${environment.apiUrl}/api/plan_anual_trabajo`;

  constructor(private http: HttpClient) {}

  // Listar todos los planes
  getAll(): Observable<PlanAnualTrabajo[]> {
    return this.http.get<PlanAnualTrabajo[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<PlanAnualTrabajo> {
    return this.http.get<PlanAnualTrabajo>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Crear nuevo plan
  create(payload: PlanAnualTrabajoPayload): Observable<PlanAnualTrabajoResponse> {
    return this.http.post<PlanAnualTrabajoResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar plan
  update(id: number, payload: Partial<PlanAnualTrabajoPayload>): Observable<PlanAnualTrabajoResponse> {
    return this.http.put<PlanAnualTrabajoResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar plan (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar plan
  inactivar(id: number): Observable<PlanAnualTrabajoResponse> {
    return this.http.put<PlanAnualTrabajoResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar plan
  activar(id: number): Observable<PlanAnualTrabajoResponse> {
    return this.http.put<PlanAnualTrabajoResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }

  getPlanGeneral(id: number): Observable<PlanAnualTrabajo> {
    return this.http.get<PlanAnualTrabajo>(`${this.apiUrl}/general/${id}`, { withCredentials: true });
  }
}

